import { CompanyUser, RoleTypes } from 'components/UsersList/UsersList';

// This function filters an array of users based on their roles.
// It returns a new array containing only the users whose role names are included in the validRoles array.
export const filterUsersByRoles = (users: CompanyUser[] = [], validRoles: RoleTypes[]) => {
  return users?.filter((user) => validRoles.includes(user?.role?.name));
};
